import React, { useState, useEffect } from 'react'
import '../assets/styles/MyPharmacie.css'
import NavigationBtns from '../components/navigationBtns';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import CryptoJS from "crypto-js"
import { ToastContainer, toast } from 'react-toastify';

export default function MyPharmacie() {
  const [pharmacie, setPharmacie] = useState(null);
  const [isOnSale, setIsOnSale] = useState(false);
  const [sellerContact, setSellerContact] = useState('');
  const [sellingPrice, setSellingPrice] = useState('');
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const getPharmacie = async () => {
    try {
      const numConnexion = localStorage.getItem('U2FsdGVkX19xqKHwGY8nQLnQc8gwVyHkcrKpJBegXRg');
      if (!numConnexion) {
        toast.error("Connexion invalide. Veuillez vous reconnecter.");
        navigate('/authRequired');
        return;
      }

      let decryptedBytes = CryptoJS.AES.decrypt(numConnexion, "MOT_DE_KEY");
      let decryptedDataString = decryptedBytes.toString(CryptoJS.enc.Utf8);
      let DecnumConnexion = JSON.parse(decryptedDataString);

      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/getPharmacien?NumeroInscription=${DecnumConnexion}`
      );

      // ✅ Handle case where Pharmacie is null or missing
      if (!response.data || !response.data.Pharmacie) {
        setPharmacie(null);
        return;
      }

      const data = response.data.Pharmacie;
      setPharmacie(data);
      setIsOnSale(data.onSale || false);
      setSellerContact(data.sellerContact || '');
      setSellingPrice(data.sellingPrice || '');

    } catch (error) {
      console.error('Error fetching pharmacie:', error);
      if (error.response) {
        toast.warn(error.response.data.message || "Erreur lors du chargement de la pharmacie.");
      } else {
        toast.error("Erreur de connexion au serveur.");
      }
    }
  };


  useEffect(() => {
    const numConnexion = localStorage.getItem('U2FsdGVkX19xqKHwGY8nQLnQc8gwVyHkcrKpJBegXRg');
    if (!numConnexion) {
      navigate('/authRequired');
      return;
    }
    getPharmacie();
  }, [navigate]);

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleSave = async () => {
    if (!pharmacie) return;
    setLoading(true);

    try {
      const formData = new FormData();
      formData.append("Id", pharmacie.Id);
      formData.append("onSale", isOnSale);
      formData.append("contact", sellerContact || '');
      formData.append("prix", sellingPrice || '');
      if (file) formData.append("attachement", file);

      const res = await axios.post(`${process.env.REACT_APP_BASE_URL}/api/updatePharmacieStatus`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      toast.success("Statut de la pharmacie mis à jour !");
      console.log("Update response:", res.data);
      await getPharmacie();

    } catch (error) {
      console.error("Error updating pharmacie:", error);
      if (error.response) {
        toast.error(error.response.data.message || "Erreur lors de la mise à jour");
      } else {
        toast.error("Erreur de connexion au serveur");
      }
    } finally {
      setLoading(false);
    }
  };

if (pharmacie === null) {
  return (
    <div className='Notifications-container'>
      <div className='inner-navbar'>
        <NavigationBtns />
      </div>
      <div className='Notifications-body scrollable-content'>
        <div className='Notifications-title-section'>
          <span className='Notifications-title'>Pharmacie</span>
          <span className='line'></span>
        </div>
        <p style={{ textAlign: 'center', marginTop: 40 }}>
          Aucune pharmacie trouvée pour ce compte.
        </p>
      </div>
    </div>
  );
}

  return (
    <div className='Notifications-container'>
      <div className='inner-navbar'>
        <NavigationBtns />
      </div>

      {/* ✅ Scrollable content */}
      <div className='Notifications-body scrollable-content'>
        <div className='Notifications-title-section'>
          <span className='Notifications-title'>Pharmacie</span>
          <span className='line'></span>
        </div>

        <div className='pharmacie-card'>
          <h3>{pharmacie.NomPharmacie}</h3>
          <p><strong>Catégorie:</strong> {pharmacie.Category}</p>
          <p><strong>Adresse:</strong> {pharmacie.Adresse}</p>
          <p><strong>Ville:</strong> {pharmacie.Ville}</p>
          <p><strong>Gouvernorat:</strong> {pharmacie.Gouvernorat}</p>
          <p><strong>Date de création:</strong> {new Date(pharmacie.DateCreation).toLocaleDateString()}</p>

          <div className='switch-section'>
            <label>Mettre en vente :</label>
            <label className="switch">
              <input
                type="checkbox"
                checked={isOnSale}
                onChange={() => setIsOnSale(!isOnSale)}
              />
              <span className="slider round"></span>
            </label>
          </div>

          {isOnSale && (
            <div className='sale-section'>
              <div className='form-group'>
                <label>Contact du vendeur :</label>
                <input
                  type="text"
                  value={sellerContact}
                  onChange={(e) => setSellerContact(e.target.value)}
                  placeholder="Ex: Mohamed Ridha"
                />
              </div>

              <div className='form-group'>
                <label>Prix de vente :</label>
                <input
                  type="number"
                  value={sellingPrice}
                  onChange={(e) => setSellingPrice(e.target.value)}
                  placeholder="Ex: 3000"
                />
              </div>

              <div className='form-group'>
                <label>Fichier joint :</label>
                <input type="file" onChange={handleFileChange} />
              </div>
            </div>
          )}

          <button className='save-btn' onClick={handleSave} disabled={loading}>
            {loading ? "Enregistrement..." : "Enregistrer"}
          </button>
        </div>

        <ToastContainer />
      </div>
    </div>
  )
}
